// extracted by mini-css-extract-plugin
export default {"wrapper":"VariantsImg_wrapper__4vQDs"};